import $ from 'jquery';
import { AJAX_URL } from './config';

// Catch when register form is submitted
$('#sports-nutrition-form').on('submit', function (e) {
  // Prevent default
  e.preventDefault();
  $('.login__submit').hide();
  $('.submit__loading').show();

  // Get form data
  const data = {
    first_name: $('[name="first_name"]').val(),
    last_name: $('[name="last_name"]').val(),
    email: $('[name="email"]').val(),
    password: $('[name="password"]').val(),
    confirm_password: $('[name="confirm_password"]').val(),
    school: $('[name="school"]').val(),
    city: $('[name="city"]').val(),
    state: $('[name="state"]').val(),
    isd: $('[name="isd"]').val(),
    position: $('input[name="position"]:checked').val(),
    position_other: $('[name="position"]').val(),
    grade_level: $('[name="grade_level"]').val(),
    grade_level_other: $('[name="grade_level_other"]').val(),
    question: $('[name="question"]').val(),
    opt_out: $('[name="opt_out"]').val(),
    redirect_to: $('[name="redirect_to"]').val()
  };

  // get selected position
  if ($('input[name="position"]:checked').length) {
    data.position = $('input[name="position"]:checked').val();
  }


  $.ajax({
    url: `${AJAX_URL}wl_post_sports_register_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      $('.login__submit').show();
      $('.submit__loading').hide();

      // scroll to div with class .login__title
      $('html, body').animate(
        { scrollTop: $('.login__title').offset().top },
        1000
      );
      if (!success) {
        $.each(data.errors, function (key, value) {
          $('#' + key)
            .parent()
            .append(
              '<small class="form__help u--color-red">' + value + '</small>'
            );
        });
        $('#notice').html(data.notice);
        return;
      } else {
        __ss_noform.push([
          'submit',
          null,
          '3f548c4c-22f1-418d-b580-be21775099b3'
        ]);
        // $('#notice').html(data.notice);
        // Redirect the user
        if (data.redirect) {
          window.location.href = data.redirect;
        }
      }
    })
    .catch((err) => console.log(err.message));
});

if ($('select[name="grade_level"]').length) {
  $('select[name="grade_level"]').on('change', function () {
    if (this.value === 'Other') {
      $('.grade_level_other_container').removeClass('u--display-none');
    } else {
      $('.grade_level_other_container').addClass('u--display-none');
    }
  });
}

if ($('input[name="position"]').length) {
  $('input[name="position"]').on('change', function () {
    if (this.value === 'Other') {
      $('.position_other_container').removeClass('u--display-none');
    } else {
      $('.position_other_container').addClass('u--display-none');
    }
  });
}
